import { createStructuredSelector } from "reselect";
import { financialStatementSelector } from "./financialStatementSelector";

/**
 * バランスシートセレクター
 */
export const balanceSheetSelector = createStructuredSelector({
  financialStatements: financialStatementSelector,
});
